export default __webpack_public_path__ + "static/media/engine.57d0cd80.png";